/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import { compose, withHandlers, withProps } from 'recompose'
import { connect } from 'react-redux'
import { createSelector } from 'reselect'
import { withLocalization } from 'hocs/localization'
import { hiddenUnmountedModal } from 'hocs/hiddenUnmountedModal'
import { closeModal } from 'redux-app/modules/modals'
import { getModalDataByName } from 'redux-app/selectors/modals'
import { getCountryById, getStateById } from 'redux-app/selectors/apiData'
import CorrectedAddressModal from './CorrectedAddressModal'

const getMessagesData = createSelector(
  (state, correctedData) => correctedData,
  (state, correctedData) => getCountryById(state, { id: correctedData.countryId }),
  (state, correctedData) => getStateById(state, { id: correctedData.stateId }),
  (correctedData, country = {}, state = {}) => ({
    ...correctedData,
    state: state.name,
  }),
)

export default name => compose(
  withProps(() => ({
    name,
  })),
  hiddenUnmountedModal(name),
  withLocalization('company.correctedAddressModal'),
  connect(
    state => {
      const {
        accessToken,
        shippingCorrectedResult,
        billingCorrectedResult,
      } = getModalDataByName(state, { name })

      const shippingMessage = shippingCorrectedResult ? getMessagesData(state, shippingCorrectedResult) : null
      const billingMessage = billingCorrectedResult ? getMessagesData(state, billingCorrectedResult) : null
      return {
        accessToken,
        shippingCorrectedResult,
        billingCorrectedResult,
        shippingMessage,
        billingMessage,
      }
    },
    {
      closeModal,
    },
  ),
  withHandlers({
    onCloseModal: ({ closeModal }) => () => closeModal({ name }),
  }),
)(CorrectedAddressModal)
